export default "dist/images/block-divider-asterisks.e534122.png";